import { FC } from "react";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { IStyledAttributes } from "@ryde/shared";

interface IGreenCheckboxCell {
  checked: boolean;
}

const GreenCheckboxCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "green-checkbox-cell",
})`
  min-width: 20px;
  display: flex;
  vertical-align: center;
  justify-content: flex-start;
`;

export const GreenCheckboxCell: FC<IGreenCheckboxCell> = ({ checked }) => {
  return (
    <GreenCheckboxCellStyled data-e2e-value={checked ? "checked" : "unchecked"}>
      {checked ? <SVG_MUI.ToggleGreenOnSVG /> : <SVG_MUI.ToggleGreenOffSVG />}
    </GreenCheckboxCellStyled>
  );
};
